import api from '../../plugins/api';

/**
 * ÐÑÑÑÑ Ð¸Ð· Ð°Ð´Ð¼Ð¸Ð½ÐºÐ¸.
 *
 * Ð¥Ð¾Ð´Ð¸Ð¼ ÑÐµÑÐµÐ· ÑÐ²Ð¾Ð¹ Ð±ÑÐºÐµÐ½Ð´, Ð° Ð½Ðµ Ð½Ð°Ð¿ÑÑÐ¼ÑÑ Ð² Ð°Ð´Ð¼Ð¸Ð½ÐºÑ: ÑÐ°Ð½ÑÑÐµ Ð·Ð°Ð¿ÑÐ¾Ñ ÑÑÐ¾Ð´Ð¸Ð» Ð¸Ð·
 * Ð±ÑÐ°ÑÐ·ÐµÑÐ° Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ° Ð½Ð° admin.doscar.kz, Ð¸ Ñ ÑÐµÑ, Ñ ÐºÐ¾Ð³Ð¾ Ð½ÐµÑ Ð´Ð¾ÑÑÑÐ¿Ð° Ðº Ð°Ð´Ð¼Ð¸Ð½ÐºÐµ,
 * ÑÐºÐ°ÑÐ¸Ð²Ð°Ð½Ð¸Ðµ Ð¿Ð°Ð´Ð°Ð»Ð¾ Ñ Ð¾ÑÐ¸Ð±ÐºÐ¾Ð¹ CORS. ÐÑÐºÐµÐ½Ð´ Ð·Ð°Ð±Ð¸ÑÐ°ÐµÑ ÑÐ°Ð¹Ð» ÑÐ¾ ÑÐ²Ð¾ÐµÐ¹ ÑÑÐ¾ÑÐ¾Ð½Ñ Ð¸
 * Ð¾ÑÐ´Ð°ÑÑ ÐµÐ³Ð¾ Ð½Ð°Ð¼ â Ð´Ð¾ÑÑÑÐ¿ Ðº Ð°Ð´Ð¼Ð¸Ð½ÐºÐµ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð±Ð¾Ð»ÑÑÐµ Ð½Ðµ Ð½ÑÐ¶ÐµÐ½.
 */
const downloadReport = (data) => {
  return api.post('/api/crm/reports/download', data, { responseType: 'blob' });
};

export default downloadReport;
